import axios from "axios"

class Search {
  // 1. describe and create/initiate our object
  constructor() {
    this.addSearchHTML()
    this.resultsDiv = document.querySelector("#search-overlay__results")
    this.openButton = document.querySelectorAll(".js-search-trigger")
    this.closeButton = document.querySelector(".search-overlay__close")
    this.searchOverlay = document.querySelector(".search-overlay")
    this.searchField = document.querySelector("#search-term")
    this.clearSearch = document.querySelector("#clear-search-input")
    this.searchIcon = document.querySelector("#search-input-icon")
    this.isOverlayOpen = false
    this.isSpinnerVisible = false
    this.previousValue
    this.typingTimer
    this.events()
  }

  // 2. events
  events() {
    this.openButton.forEach(el => {
      el.addEventListener("click", e => {
        e.preventDefault()
        this.openOverlay()
      })
    })

    this.closeButton.addEventListener("click", () => this.closeOverlay())
    document.addEventListener("keydown", e => this.keyPressDispatcher(e))
    this.searchField.addEventListener("keyup", () => this.typingLogic())
    this.clearSearch.addEventListener("click", () => this.clearSearchInput())
    this.searchIcon.addEventListener("click", () => this.setSearchInputActive())
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.value != this.previousValue) {
      clearTimeout(this.typingTimer)

      if (this.searchField.value) {
        if (!this.isSpinnerVisible) {
          const spinner = `
            <div class="flex items-center justify-center">
              <div class="w-8 h-8 border-4 border-gray-300 border-t-gray-800 rounded-full animate-spin"></div>
            </div>
          `
          // this.resultsDiv.innerHTML = '<div class="spinner-loader"></div>'
          this.resultsDiv.innerHTML = spinner
          this.isSpinnerVisible = true
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750)
      } else {
        this.resultsDiv.innerHTML = ""
        this.isSpinnerVisible = false
      }
    }

    this.previousValue = this.searchField.value
  }

  async getResults() {
    try {
      const response = await axios.get(universityData.root_url + "/wp-json/talents/v1/search?term=" + this.searchField.value)
      const results = response.data
      console.log(results)
      this.resultsDiv.innerHTML = `
        <div class="flex">
          <div class="w-2/3 pr-5 mr-5 border-r border-r-gray-300">
            <h4 class="text-2xl mb-3">Articles</h4>
            <div>
              ${results.generalInfo.length ? '<ul class="flex flex-col gap-3">' : "<p>No articles matches that search.</p>"}
                ${results.generalInfo.map(item => `<li><a href="${item.permalink}" class="flex items-center gap-3 border border-gray-300"><img src="${item.thumbnail}" class="w-[100px] h-[100px]" /><h4 className="text-2xl">${item.title}</h4></a></li>`).join("")}
              ${results.generalInfo.length ? "</ul>" : ""}
            </div>
          </div>
          <div class="w-1/3">
            <h4 class="text-2xl mb-3">Talents</h4>
            ${results.talents.length ? '<ul class="flex flex-col gap-3">' : "<p>No talents matches that search.</p>"}
              ${results.talents.map(item => `<li><a href="${item.link}">${item.name}</a></li>`).join("")}
            ${results.talents.length ? "</ul>" : ""}
          </div>
        </div>
      `
      this.isSpinnerVisible = false
    } catch (e) {
      console.log(e)
    }
  }

  keyPressDispatcher(e) {
    if (e.keyCode == 83 && !this.isOverlayOpen && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA") {
      this.openOverlay()
    }

    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay()
    }
  }

  openOverlay() {
    this.searchOverlay.classList.add("search-overlay--active")
    document.body.classList.add("body-no-scroll")
    this.searchField.value = ""
    setTimeout(() => this.searchField.focus(), 301)
    console.log("our open method just ran!")
    this.isOverlayOpen = true
    return false
  }

  closeOverlay() {
    this.searchOverlay.classList.remove("search-overlay--active")
    document.body.classList.remove("body-no-scroll")
    console.log("our close method just ran!")
    this.isOverlayOpen = false
    this.resultsDiv.innerHTML = ''
  }

  clearSearchInput() {
    this.searchField.value = ""
    this.searchField.focus()
  }

  setSearchInputActive() {
    this.searchField.focus()
  }

  addSearchHTML() {
    document.body.insertAdjacentHTML(
      "beforeend",
      `
      <div class="search-overlay">
        <div class="search-overlay__top">
          <div class="container">
            <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
            <input type="text" class="search-term" placeholder="What are you looking for?" id="search-term">
            <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
          </div>
        </div>
        
        <div class="container">
          <div id="search-overlay__results"></div>
        </div>

      </div>
    `
    )
  }
}

export default Search
